<template lang="pug">
  .copyright
    p ©{{ getCopyrightYear }} {{ $t('footer.copyright1') }}
    p {{ $t('footer.copyright2') }}
</template>
<script>
export default {
  name: "FooterCopyRights",
  computed: {
    getCopyrightYear() {
      return new Date().getFullYear();
    },
  },
};
</script>
